import React from 'react';

const DefaultIcon = ({ name }) => {
  const nameParts = name.split(' ');
  const firstLetterFirstPart = nameParts[0].charAt(0).toUpperCase();
  const lastLetterLastPart = nameParts[nameParts.length - 1]?.charAt(0).toUpperCase();

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: 'large',
        borderRadius: '50%',
        height: 40,
        width: 40,
        marginTop: '5px',
        backgroundColor: 'grey',
        color: 'blue',
      }}
    >
      {nameParts.length > 1 ? `${firstLetterFirstPart}${lastLetterLastPart}` : firstLetterFirstPart}
    </div>
  );
};

export default DefaultIcon;